import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'environments/environment';
import { SxErrorService } from '@services';
import { InformationVideoCategory } from '@model';

@Injectable({
  providedIn: 'root'
})
export class InformationVideosService {
  constructor(private http: HttpClient, private sxErrorService: SxErrorService) {}

  getInformationVideos(): Observable<InformationVideoCategory[]> {
    return this.http
      .get<InformationVideoCategory[]>(`${environment.apiEndpoint}/InformationVideos`)
      .pipe(catchError((error: any) => this.sxErrorService.handleError(error)));
  }

  
}
